import { Button } from 'devextreme-react/button'
import React from 'react'

import './ICSButton.css'

export type ICSButtonProps = {
  id?: string
  icon?: string
  type?: 'back' | 'danger' | 'default' | 'normal' | 'success' | undefined
  width?: number | string
  height?: number | 35 | string
  stylingMode?: 'text' | 'outlined' | 'contained' | undefined
  className?: string
  onClick?: (unknown) => void
  // tood use proper typing here (from inered type below)
  //   ((e: {
  //     component?: dxButton | undefined;
  //     element?: dxElement | undefined;
  //     model?: any;
  //     event?: event | undefined;
  //     validationGroup?: any;
  // }) => any)
  text?: string
  children?: React.ReactNode
  useSubmitBehavior?: boolean
  disabled?: boolean
  hoverStateEnabled?: boolean
}

const ICSButton: React.FC<ICSButtonProps> = (props) => {
  return (
    <Button
      id={props.id}
      icon={props.icon}
      type={props.type}
      width={props.width}
      height={props.height}
      stylingMode={props.stylingMode}
      onClick={props.onClick}
      text={props.text}
      className={
        `${props.className} ics-button`
      }
      useSubmitBehavior={props.useSubmitBehavior}
      disabled={props.disabled}
      hoverStateEnabled={props.hoverStateEnabled}
      style={{fontSize:'12px'}}
    >
      {props.children}
    </Button>
  )
}

ICSButton.defaultProps = {
  height: 35,
  hoverStateEnabled: true
}

export default ICSButton
